module.exports = {
	"config": {
		"blogTitle": "Idées aléatoires",
		"authorName": "Tycho Tatitscheff",
		"linkPrefix": "/"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"path": "2012-02-25---bonjour/Index.md",
				"isAbsolute": false,
				"absolute": "/home/tychota/Documents/code/perso/blog/2012-02-25---bonjour/Index.md",
				"root": "",
				"dirname": "2012-02-25---bonjour",
				"basename": "Index.md",
				"extname": ".md",
				"name": "Index",
				"ext": "md"
			},
			"requirePath": "2012-02-25---bonjour/Index.md",
			"path": "/lancement-blog/",
			"data": {
				"title": "Je lance mon blog - les explications",
				"date": "2016-02-25T14:51:03.284Z",
				"layout": "post",
				"path": "/lancement-blog/"
			}
		},
		{
			"file": {
				"path": "2015-05-01-hello-world/index.md",
				"isAbsolute": false,
				"absolute": "/home/tychota/Documents/code/perso/blog/2015-05-01-hello-world/index.md",
				"root": "",
				"dirname": "2015-05-01-hello-world",
				"basename": "index.md",
				"extname": ".md",
				"name": "index",
				"ext": "md"
			},
			"requirePath": "2015-05-01-hello-world/index.md",
			"path": "/hello-world/",
			"data": {
				"title": "Hello World",
				"date": "2015-05-01T22:12:03.284Z",
				"layout": "post",
				"readNext": "/my-second-post/",
				"path": "/hello-world/"
			}
		},
		{
			"file": {
				"path": "2015-05-06-my-second-post/index.md",
				"isAbsolute": false,
				"absolute": "/home/tychota/Documents/code/perso/blog/2015-05-06-my-second-post/index.md",
				"root": "",
				"dirname": "2015-05-06-my-second-post",
				"basename": "index.md",
				"extname": ".md",
				"name": "index",
				"ext": "md"
			},
			"requirePath": "2015-05-06-my-second-post/index.md",
			"path": "/my-second-post/",
			"data": {
				"title": "My Second Post!",
				"date": "2015-05-06T23:46:37.121Z",
				"layout": "post",
				"readNext": "/hi-folks/",
				"path": "/my-second-post/"
			}
		},
		{
			"file": {
				"path": "2015-05-28-hi-folks/index.md",
				"isAbsolute": false,
				"absolute": "/home/tychota/Documents/code/perso/blog/2015-05-28-hi-folks/index.md",
				"root": "",
				"dirname": "2015-05-28-hi-folks",
				"basename": "index.md",
				"extname": ".md",
				"name": "index",
				"ext": "md"
			},
			"requirePath": "2015-05-28-hi-folks/index.md",
			"path": "/hi-folks/",
			"data": {
				"title": "New Beginnings",
				"date": "2015-05-28T22:40:32.169Z",
				"layout": "post",
				"readNext": "/hosting-static-sites-with-docker-and-nginx/",
				"path": "/hi-folks/"
			}
		},
		{
			"file": {
				"path": "2016-02-25---ajout-d-un-flux-rss/index.md",
				"isAbsolute": false,
				"absolute": "/home/tychota/Documents/code/perso/blog/2016-02-25---ajout-d-un-flux-rss/index.md",
				"root": "",
				"dirname": "2016-02-25---ajout-d-un-flux-rss",
				"basename": "index.md",
				"extname": ".md",
				"name": "index",
				"ext": "md"
			},
			"requirePath": "2016-02-25---ajout-d-un-flux-rss/index.md",
			"path": "/ajout-flux-rss",
			"data": {
				"title": "Update de ce blog - Ajout d'un flux RSS",
				"date": "2016-02-25T17:45:23.015Z",
				"layout": "post",
				"path": "/ajout-flux-rss"
			}
		},
		{
			"file": {
				"path": "2016-02-25---ajout-disqus/index.md",
				"isAbsolute": false,
				"absolute": "/home/tychota/Documents/code/perso/blog/2016-02-25---ajout-disqus/index.md",
				"root": "",
				"dirname": "2016-02-25---ajout-disqus",
				"basename": "index.md",
				"extname": ".md",
				"name": "index",
				"ext": "md"
			},
			"requirePath": "2016-02-25---ajout-disqus/index.md",
			"path": "/ajout-disqus/",
			"data": {
				"title": "Update de ce blog - Ajout disqus",
				"date": "2016-02-25T19:46:30.783Z",
				"layout": "post",
				"path": "/ajout-disqus/"
			}
		},
		{
			"file": {
				"path": "2016-05-02---the-phoenix-project/index.md",
				"isAbsolute": false,
				"absolute": "/home/tychota/Documents/code/perso/blog/2016-05-02---the-phoenix-project/index.md",
				"root": "",
				"dirname": "2016-05-02---the-phoenix-project",
				"basename": "index.md",
				"extname": ".md",
				"name": "index",
				"ext": "md"
			},
			"requirePath": "2016-05-02---the-phoenix-project/index.md",
			"path": "/2016-05-02---the-phoenix-project/",
			"data": {
				"title": "The Phoenix Project",
				"date": "2016-05-02T20:35:30.569Z",
				"layout": "post",
				"draft": true
			}
		},
		{
			"file": {
				"path": "404.md",
				"isAbsolute": false,
				"absolute": "/home/tychota/Documents/code/perso/blog/404.md",
				"root": "",
				"dirname": "",
				"basename": "404.md",
				"extname": ".md",
				"name": "404",
				"ext": "md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html"
			}
		},
		{
			"file": {
				"path": "_template.js",
				"isAbsolute": false,
				"absolute": "/home/tychota/Documents/code/perso/blog/_template.js",
				"root": "",
				"dirname": "",
				"basename": "_template.js",
				"extname": ".js",
				"name": "_template",
				"ext": "js"
			},
			"requirePath": "_template.js",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"path": "index.js",
				"isAbsolute": false,
				"absolute": "/home/tychota/Documents/code/perso/blog/index.js",
				"root": "",
				"dirname": "",
				"basename": "index.js",
				"extname": ".js",
				"name": "index",
				"ext": "js"
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		}
	]
}


/*****************
 ** WEBPACK FOOTER
 ** ../config.toml
 ** module id = 338
 ** module chunks = 0
 **/